module.exports = __webpack_public_path__ + "static/media/Sharp-MIP-3-5-inch-LS035Q7DD01.1344fecd.jpg";